(ns ductile.ui.agent.policy
  (:require [clojure.set :as set]
            [clojure.string :as str]))

(defn eval-references-attr-key?
  [code]
  (boolean (re-find #":[a-zA-Z0-9\.\-]+/[a-zA-Z0-9\.\-\?\!]+" (str code))))

(defn eval-referenced-attr-keys
  [code]
  (set (re-seq #":[a-zA-Z0-9\.\-]+/[a-zA-Z0-9\.\-\?\!]+" (str code))))

(defn direct-key-access-on-data?
  [code]
  (let [s (str code)]
    (or (boolean (re-find #"\(:[a-zA-Z0-9\.\-]+/[a-zA-Z0-9\.\-\?\!]+\s+data\)" s))
        (boolean (re-find #"\(get\s+data\s+:[a-zA-Z0-9\.\-]+/[a-zA-Z0-9\.\-\?\!]+\)" s)))))

(defn singleton-fahrzeug-data
  [tool-datasets latest-dataset-id dataset-id]
  (let [selected-dataset-id (or dataset-id latest-dataset-id)
        kind (get-in tool-datasets [selected-dataset-id :kind])
        data (get-in tool-datasets [selected-dataset-id :data])]
    (if (and (= kind :fahrzeuge)
             (sequential? data)
             (= 1 (count data))
             (map? (first data)))
      (first data)
      data)))

(defn dataset-context-keys
  [tool-datasets latest-dataset-id dataset-id]
  (let [selected-dataset-id (or dataset-id latest-dataset-id)
        data (singleton-fahrzeug-data tool-datasets latest-dataset-id selected-dataset-id)
        rows (cond
               (map? data) [data]
               (and (sequential? data) (every? map? (take 25 data))) (take 25 data)
               :else nil)]
    (->> rows
         (mapcat keys)
         (filter keyword?)
         (map str)
         distinct
         vec)))

(defn attr-key-str->kw
  [s]
  (when (string? s)
    (let [s (str/trim s)
          s (if (str/starts-with? s ":") (subs s 1) s)]
      (when (str/includes? s "/")
        (keyword s)))))

(defn value-shape
  [v]
  (cond
    (nil? v) :nil
    (string? v) :string
    (map? v) :map
    (and (sequential? v) (not (string? v)) (every? map? (take 20 v))) :seq-of-maps
    (and (sequential? v) (not (string? v))) :seq
    :else :scalar))

(defn rewrite-safe?
  [{:keys [tool-datasets latest-dataset-id dataset-id old-key-str new-key-str]}]
  (let [old-kw (attr-key-str->kw old-key-str)
        new-kw (attr-key-str->kw new-key-str)
        data (singleton-fahrzeug-data tool-datasets latest-dataset-id dataset-id)
        old-v (when (and old-kw (map? data)) (get data old-kw))
        new-v (when (and new-kw (map? data)) (get data new-kw))
        old-shape (value-shape old-v)
        new-shape (value-shape new-v)]
    (cond
      (or (nil? old-kw) (nil? new-kw)) false
      (= old-shape :nil) false
      (= new-shape :nil) false
      (= old-shape new-shape) true
      (and (= old-shape :seq-of-maps) (= new-shape :seq)) true
      (and (= old-shape :seq) (= new-shape :seq-of-maps)) true
      :else false)))

(defn referenced-root-keys
  [context-keys referenced-keys]
  (set/intersection (set context-keys) referenced-keys))
